controllers.controller('WithdrawController', [
    '$scope', '$state', 'LocaleService', 'UserService', 'constants', 'Storage', 'config', 'Utils', '$ionicPopover',
    'API',
    function ($scope, $state, LocaleService, UserService, Const, Storage, config, Utils, $ionicPopover, API) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.constants = Const;
        $scope.formValidator = false;
        $scope.accountConfig = {
            type: 'withdraw'
        };
        $scope.withdrawAditionalText = $scope.constants['withdrawAditionalText'] || '';

        $scope.config = {
            digits: 2,
            step: 1,
            min: 50,
            max: 100000
        };
        $scope.changeStep = config.stepChange;

        $scope.accounts = $scope.user.tradingAccounts
            .filter(function (account) {
                return account.live;// && account.balance > 0
            })
            .map(function (account) {
                var currencySymbol = Const.currencySymbols[account.currency],
                    balance = account.balance.toFixed($scope.user.currencyDigits),
                    fundsToWithdraw = Math.min(account.freeMargin - account.credit, account.balance);
                account.fundsToWithdraw = fundsToWithdraw > 0 ? fundsToWithdraw : 0;
                account.description = [account.login, 'LIVE', $scope.translation.balance, currencySymbol, balance].join(' ');
                account.minWithdrawal = (_.find(Storage.get('currencies'), {currency: account.currency}) || {})['minWithdrawal'];
                return account;
            });

        var activeTradingAccount = $scope.accounts
            .filter(function (account) {
                return account.active
            }).shift();

        $scope.withdraw = {
            account: activeTradingAccount || $scope.accounts[0],
            value: 50,
            fundsToWithdraw: 0
        };

        var accountWatch = $scope.$watch('withdraw.account', function (newVal, oldVal) {
            if (!$scope.withdraw.account) {
                return;
            }

            API.customerWithdrawalMethods({
                login: $scope.withdraw.account.login,
                source: $scope.withdraw.account.source
            }, $scope.user)
                .then(function (response) {
                    $scope.withdraw.account.minWithdrawal = Number(response.data.minWithdrawal);
                    var minWithdrawal = $scope.withdraw.account && $scope.withdraw.account.minWithdrawal || 50;
                    $scope.config.digits = $scope.withdraw.account && $scope.withdraw.account.currencyDigits || 2;
                    $scope.config.step = 1;
                    $scope.config.min = minWithdrawal;
                    $scope.withdraw.value = minWithdrawal;

                    $scope.withdraw.fundsToWithdraw = $scope.withdraw.account ? $scope.withdraw.account.fundsToWithdraw : 0;
                })
                .catch(function (error) {
                    console.warn(error);
                })
        });

        $scope.withdraw.value = $scope.withdraw.account && $scope.withdraw.account.minWithdrawal || 50;
        $scope.withdraw.fundsToWithdraw = $scope.withdraw.account ? $scope.withdraw.account.fundsToWithdraw : 0;

        var withdrawValueWatch = $scope.$watch('withdraw.value', function (newOld, oldVal) {
            $scope.formValidator = newOld && (newOld > 0 && newOld <= $scope.withdraw.account.fundsToWithdraw);
        });

        //region PaymentMethod
        $scope.paymentTypes = Storage
            .get('withdrawalMethods')
            .map(function (method) {
                var type = Utils.toCamelCase(method);
                return {id: type, label: $scope.translation[type] || type.charAt(0).toUpperCase() + type.slice(1)};
            });

        $scope.selectedModel = {};

        $scope.selectedModel.selectedPaymentMethod = $scope.paymentTypes.slice(0, 1).pop();
        //endregion

        $scope.submit = function (form) {
            if (!form.$valid) {
                return;
            }

            if ($scope.withdraw.value > 0 && $scope.withdraw.value <= $scope.withdraw.fundsToWithdraw) {
                var transitionTo = "root.app.withdraw-{state}".replace('{state}', $scope.selectedModel.selectedPaymentMethod.id);
                return $state.go(transitionTo, {
                    login: $scope.withdraw.account.login,
                    amount: $scope.withdraw.value
                });
            }
        };

        $ionicPopover.fromTemplateUrl('templates/wallet-menu.html', {
            scope: $scope.$new()
        }).then(function (popover) {
            $scope.popover = popover;
        });

        $scope.openPopover = function ($event) {
            $scope.popover.show($event);
        };

        $scope.navigate = function (state, params) {
            $scope.popover && $scope.popover.remove();
            $state.go(state, params);
        };

        $scope.$on('$ionicView.beforeEnter', function () {
            var user = UserService.get();
            if (Const['kycCheck'] && user.complianceStatus === 'partial kyc - can trade') {
                return $state.go('kycCheck', {cache: false})
            }
            return UserService.kycCheck();
        });

        $scope.$on('$ionicView.beforeLeave', function (event) {
            accountWatch();
            withdrawValueWatch();
        });


        function clear() {
            $scope.popover.remove();
        }

        //$scope.$on('clear', clear);

    }]);
